export default __webpack_public_path__ + "static/VitalySemyonov-6eec42629055e4ebace1697e4e9b439d.png";